import { Heading } from '@digdir/designsystemet-react'
import { useLanguage } from '@i18n'
import './Help.css'

const externalLinkProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

type HelpLink =
  | {
      href: string
      title: string
      external?: boolean
    }
  | {
      href: string
      titleKey: string
      external?: boolean
    }

const helpLinks: HelpLink[] = [
  {
    href: 'https://www.sdir.no/',
    title: 'sdir.no',
  },
  {
    href: 'https://www.sdir.no/kontakt-oss/',
    titleKey: 'help.contact',
    external: false,
  },
  {
    href: 'https://uustatus.no/nb/erklaringer/publisert/bb43bccd-8b47-4f8f-9843-a1cf70875ff2',
    titleKey: 'help.accessibility',
  },
]

const socialLinks: HelpLink[] = [
  {
    href: 'https://www.facebook.com/sjofartsdir',
    title: 'Facebook',
  },
  {
    href: 'https://www.instagram.com/sjofartsdir/',
    title: 'Instagram',
  },
  {
    href: 'https://www.linkedin.com/company/41031/',
    title: 'LinkedIn',
  },
]

type HelpLinkItemProps = {
  href: string
  title: string
  external?: boolean
}

const HelpLinkItem = ({ href, title, external = true }: HelpLinkItemProps) => (
  <li>
    <a className="help__link" href={href} {...(external ? externalLinkProps : {})}>
      <span>{title}</span>
      <span className="help__link-icon" aria-hidden="true" />
    </a>
  </li>
)

const getHelpLinkTitle = (link: HelpLink, t: (key: string) => string) =>
  'titleKey' in link ? t(link.titleKey) : link.title

export const Help = () => {
  const { t } = useLanguage()

  return (
    <section className="help">
      <div className="help__hero">
        <Heading level={1} data-size="xl">
          {t('help.title')}
        </Heading>
      </div>

      <div className="help__grid">
        <section className="help__group" aria-label="Sdir.no">
          <ul className="help__links">
            {helpLinks.map((link) => (
              <HelpLinkItem
                key={link.href}
                href={link.href}
                title={getHelpLinkTitle(link, t)}
                external={link.external}
              />
            ))}
          </ul>
        </section>

        <section className="help__group" aria-labelledby="help-social-title">
          <Heading id="help-social-title" level={2} data-size="sm">
            {t('help.followUs')}
          </Heading>
          <ul className="help__links">
            {socialLinks.map((link) => (
              <HelpLinkItem
                key={link.href}
                href={link.href}
                title={getHelpLinkTitle(link, t)}
                external={link.external}
              />
            ))}
          </ul>
        </section>
      </div>
    </section>
  )
}

export default Help
